import {INTERVENE_JS_DEVICE_INTERVENE} from '@/enmus/PageNames';

export default {
    component: () => import('@/views/intervene/jsDeviceIntervene/index.vue'),
    path: 'jsDeviceIntervene',
    name: INTERVENE_JS_DEVICE_INTERVENE,
    meta: {
        title: 'JS设备干预',
        name: INTERVENE_JS_DEVICE_INTERVENE
    }
};